export const HTTP_BAD_REQUEST = 400;
export const HTTP_SERVER_ERROR = 500;
export const HTTP_OK = 200;
export const HTTP_NO_CONTENT = 204;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_CONFLICT = 409;
